import { createContext } from 'react';
import type { InterviewSetting } from 'src/packages/polaris/types';

type AppContextType = {
  isOpen?: boolean;
  setIsPopUpOpen?: (isOpen: boolean) => void;
  interviewSettings?: InterviewSetting[];
};

const AppContext = createContext<AppContextType>({});

export default AppContext;
